import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './view-toggle.scss';

export const ViewToggle = ({ currentView, onViewChange, className = null }) => {
  const handleViewChange = useCallback(
    event => {
      onViewChange(event.target.value);
    },
    [onViewChange]
  );

  return (
    <fieldset
      className={classnames('view-toggle d-flex align-items-center', className)}
      data-tracking-parent="edm-lease-deals-view-toggle"
    >
      <legend className="visually-hidden">Choose the list view</legend>

      <input
        type="radio"
        id="grid"
        name="view-toggle-option"
        value="grid"
        checked={currentView === 'grid'}
        onChange={handleViewChange}
        className="visually-hidden"
      />
      <label
        htmlFor="grid"
        aria-label="Grid view"
        className={classnames('text-center text-white m-0', { 'opacity-50': currentView === 'list' })}
        data-tracking-id="select_grid_view"
      >
        <i className="icon-grid6 size-18" aria-hidden="true" />
      </label>

      <div className="vr opacity-25 mx-1 bg-white" />

      <input
        type="radio"
        id="list"
        name="view-toggle-option"
        value="list"
        checked={currentView === 'list'}
        onChange={handleViewChange}
        className="visually-hidden"
      />
      <label
        htmlFor="list"
        aria-label="Compact View"
        className={classnames('text-center text-white m-0', { 'opacity-50': currentView === 'grid' })}
        data-tracking-id="select_list_view"
      >
        <i className="icon-menu7 size-20" aria-hidden="true" />
      </label>
    </fieldset>
  );
};

ViewToggle.propTypes = {
  currentView: PropTypes.oneOf(['grid', 'list']).isRequired,
  onViewChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};
